import { useLoginSecurity } from '~/components/Auth/Login/Security/LoginSecurity.hooks';
import { useEvolutions } from '~/components/Evolve/Evolve.hooks';
import { AdditionalNftModel } from '~/components/Membership/Membership.hooks';
import { useSecurity, UseSecurityOptions } from '~/components/Security';

export const useEvolveFormSecurity = (
  tokenType: AdditionalNftModel['tokenType'],
  options?: Optional<UseSecurityOptions, 'values' | 'validate'>
) => {
  const login = useLoginSecurity({ enabled: false, useErrorBoundary: true });
  const { data, isFetchedAfterMount } = useEvolutions();

  return useSecurity({
    values: [...login.values, data],
    validate: () => {
      login.validate();

      const isValidTokenType = data.getReady.some((each) => each.tokenType === tokenType);
      if (isFetchedAfterMount && !isValidTokenType) return 'NOT_FOUND';
    },
    ...options,
  });
};
